export default {
    "fr": {
        "My account": "Mon compte",
        "Login": "Me connecter",
        "Email": "Email",
        "User": "Identifiant",
        "Password": "Mot de passe",
        "Show password": "Voir le mot de passe",
        "Hide password": "Masquer le mot de passe",
        "Logout": "Me déconnecter",
        "Go to account": "Accéder à votre compte",
        "No account ?": "Pas encore de compte ?",
        "Sign up": "Inscrivez-vous",
        "Loading": "Chargement ...",
        "You are almost there": "Votre compte vous attend !",
        "Set your credentials": "Renseignez vos identifiants",
        "Forget password ?": "Mot de passe oublié ?",
        "We are glad to see you": "Nous vous attendions !",
        "Set your informations": "Renseignez vos informations",
        "Create my account": "Créer mon compte",
        "You forgot your password ?": "Vous avez oublié votre mot de passe ?",
        "We will fix that": "Aucun problème, nous allons régler cela",
        "Receive reset link": "Recevoir l'email de réinitialisation",
        "We just sent you the reset email": "Nous vous avons envoyé par email le lien de réinitialisation du mot de passe !",
        "The provided two factor authentication code was invalid.": "Le code de vérification est invalide.",
        "The provided two factor recovery code was invalid.": "Le code de récupération est invalide."
    },
    "en": {
        "My account": "My account",
        "Login": "Login",
        "Email": "Email",
        "User": "Login",
        "Password": "Password",
        "Show password": "View password",
        "Hide password": "Hide password",
        "Logout": "Logout",
        "Go to account": "Set your credentials",
        "No account ?": "No account yet ?",
        "Sign up": "Register",
        "Loading": "Loading ...",
        "You are almost there": "You are almost there !",
        "Set your credentials": "Set your credentials",
        "Forget password ?": "Forgot password ?",
        "We are glad to see you": "We are glad to see you !",
        "Set your informations": "Set your informations",
        "Create my account": "Create my account",
        "You forgot your password ?": "You forgot your password ?",
        "We will fix that": "No problem, we will fix that",
        "Receive reset link": "Receive reset link",
        "We just sent you the reset email": "We just sent you the reset email",
        "The provided two factor authentication code was invalid.": "The provided two factor authentication code was invalid."
    }
}
